import { combineReducers } from 'redux';

// import mapReducer from './domains/map/reducer';
import locationsReducer from './domains/locations/reducer';

export default combineReducers({
  // map: mapReducer,
  locations: locationsReducer
});
